import React from 'react';
import PropTypes from 'prop-types';
import { StyledRadio } from './elements';

var RadioBullet = function RadioBullet(_ref) {
  var isChecked = _ref.isChecked,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(StyledRadio, {
    className: isChecked ? 'checked' : '',
    disabled: disabled,
    "data-testid": "styled-radio"
  });
};

RadioBullet.propTypes = {
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool
};
RadioBullet.defaultProps = {
  isChecked: false,
  disabled: false
};
export default RadioBullet;